import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpHeaders, HttpHeaderResponse, HttpRequest } from '@angular/common/http';
//import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
// import 'rxjs/add/operator/map';
import { map ,delay} from 'rxjs/operators';

import { AppGlobals } from '../shared/app.global';



  

@Injectable()
export class AttendanceService {

    callurl: string = '';
  
    clcd:string;
    aycd:string;
    usid:string;
    role: string;
    
        constructor(private http: HttpClient,private _global: AppGlobals) {
    
           this.clcd=localStorage.getItem('clcd');
           this.aycd=localStorage.getItem('aycd');
           this.usid=localStorage.getItem('usid');
            this.role=localStorage.getItem('role');
         
           this.callurl=_global.baseAPIUrl;
         }

         
 getdatetoday()
   {
    debugger
    let d: Date = new Date();
    var mnth;
    var day='';
    //let todayDate = {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()};
    if(d.getMonth()>=9)
    {
      mnth=d.getMonth()+1;
    }
    else{
     // mnth='0'+d.getMonth()+1;
     mnth=d.getMonth()+1;
     mnth='0'+mnth;
    }
 
    if(d.getDate()>=10)
    {
      day=d.getDate().toString();
    }
    else{
      day='0'+d.getDate();
    }
    let todayDate =  d.getFullYear()+'-'+ mnth+'-' +day;
      
 return todayDate;
 
   }
        
  by_sp_clmattendance(attdtdata: any): Observable<any> {
    return this.http.post(this._global.baseAPIUrl + 'by_sp_clmattendance', attdtdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data.byclmattendance;
        }));
}

by_sp_clmattendanceperiod(attdtdata: any): Observable<any> {
  return this.http.post(this._global.baseAPIUrl + 'by_sp_clmattendanceperiod_new', attdtdata)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
      }));
}

getattsumper(attdtdata: any): Observable<any> {
  attdtdata.clcd=this.clcd;
  attdtdata.aycd=this.aycd;
  return this.http.post(this._global.baseAPIUrl + 'getattpercorrect', attdtdata)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.attsum;
      }));
}

getattsumpercmb(attdtdata: any): Observable<any> {
  attdtdata.clcd=this.clcd;
  attdtdata.aycd=this.aycd;
  return this.http.post(this._global.baseAPIUrl + 'getattpercmbcorrect', attdtdata)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.attsum;
      }));
}

getattsumses(attdtdata: any): Observable<any> {
  attdtdata.clcd=this.clcd;
  attdtdata.aycd=this.aycd;
  return this.http.post(this._global.baseAPIUrl + 'getattsescorrect', attdtdata)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.attsum;
      }));
}

deleteattendance(attdtdata: any): Observable<any> {
  attdtdata.clcd=this.clcd;
  attdtdata.aycd=this.aycd;
  return this.http.post(this._global.baseAPIUrl + 'deleteattendance', attdtdata)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
      }));
}

getstafftimesheet(attdtdata: any): Observable<any> {
  attdtdata.clcd=this.clcd;
  attdtdata.aycd=this.aycd;
  attdtdata.oprtype1=attdtdata.oprtype
  return this.http.post(this._global.baseAPIUrl + 'getstafftimesheet', attdtdata)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.attsum;
      }));
}

attsumsub(attdtdata: any): Observable<any> {
  attdtdata.clcd=this.clcd;
  attdtdata.aycd=this.aycd;
  attdtdata.oprtype1="sum_subwise";
  return this.http.post(this._global.baseAPIUrl + 'attsumsub', attdtdata)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.attsum;
      }));
}

attsumsub1(attdtdata: any): Observable<any> {
  attdtdata.clcd=this.clcd;
  attdtdata.aycd=this.aycd;
  //attdtdata.oprtype1="sum_subwise";
  return this.http.post(this._global.baseAPIUrl + 'attsumsub1', attdtdata)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.attsum;
      }));
}

attsumsess(attdtdata: any): Observable<any> {
  attdtdata.clcd=this.clcd;
  attdtdata.aycd=this.aycd;
  //attdtdata.oprtype1="sum_subwise";
  return this.http.post(this._global.baseAPIUrl + 'attsumsess', attdtdata)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.attsum;
      }));
}
getattdet(attdtdata: any): Observable<any> {
  attdtdata.clcd=this.clcd;
  attdtdata.aycd=this.aycd;
  return this.http.post(this._global.baseAPIUrl + 'getattdet', attdtdata)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.attdetlst;
      }));
}
loop_clmattendance(attdtdata: any): Observable<any> {
  attdtdata.emid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'loop_attendance', attdtdata)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data;
        }));
}

loop_clmattendanceperiod(attdtdata: any): Observable<any> {
  attdtdata.emid=this.usid;
  return this.http.post(this._global.baseAPIUrl + 'loop_attendanceperiod_new', attdtdata)
      .pipe(map((data: any) => {
          console.log('retres', 'response');
          return data;
      }));
}

loop_clmattendanceperiod_topic(attdtdata: any): Observable<any> {
  attdtdata.emid=this.usid;
  return this.http.post(this._global.baseAPIUrl + 'loop_attendanceperiod_topic', attdtdata)
      .pipe(map((data: any) => {
          console.log('retres', 'response');
          return data;
      }));
}


saveatthcordetails(attdtdata: any): Observable<any> {
  attdtdata.usid=this.usid;
    attdtdata.clcd=this.clcd;
  attdtdata.aycd=this.aycd;
  return this.http.post(this._global.baseAPIUrl + 'saveatthcordetails', attdtdata)
      .pipe(map((data: any) => {
          console.log('retres', 'response');
          return data;
      }));
}
sendsms(empdata: any): Observable<any> {
  empdata.ayid='16';
  empdata.usid=this.usid;
  empdata.clcd=this.clcd;
  empdata.aycd=this.aycd;
  return this.http.post(this._global.baseAPIUrl + 'smsabsentees', empdata)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
      }));
}

sendsmspr(empdata: any): Observable<any> {
  empdata.ayid='16';
  empdata.usid=this.usid;
  empdata.clcd=this.clcd;
  empdata.aycd=this.aycd;
  return this.http.post(this._global.baseAPIUrl + 'smsabsenteesper', empdata)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
      }));
}
savecbmclassd(obj,arrdata): Observable<any> {
  obj.usid=this.usid;
  obj.clcd=this.clcd;
  obj.aycd=this.aycd;
  obj.stuarr=arrdata;
    return this.http.post(this._global.baseAPIUrl + 'savecbmclassd', obj)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data;
        }));
}

delcbmclassd(rid): Observable<any> {

    return this.http.get(this._global.baseAPIUrl + 'delcombclassdet/'+this.clcd+'/'+this.aycd+'/'+rid)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data;
        }));
}

getattcmbdet(cbclid) {
  let clcd=this.clcd;
  let aycd=this.aycd;
 
  //let cbclid=obj.cbclid;
  return this.http.get(this._global.baseAPIUrl + 'getcombclassdet/'+clcd+'/'+aycd+'/'+cbclid)
      .pipe(map((data: any) => {
          return data.arrcmbdet;
      }));
}


getroomallocationdata(attdtdata: any): Observable<any> {
  return this.http.post(this._global.baseAPIUrl + 'getroomallocationdata', attdtdata)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.stulst;
      }));
}

updateroomstatus(obj,status): Observable<any> {
  obj.usid=this.usid;
  obj.clcd=this.clcd;
  obj.aycd=this.aycd;
  obj.status=status;
  // obj.stuarr=arrdata;
    return this.http.post(this._global.baseAPIUrl + 'updateroomstatus', obj)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data;
        }));
}


getattstfdash(cbclid) {
  let clcd=this.clcd;
  let aycd=this.aycd;
 
  //let cbclid=obj.cbclid;
  return this.http.post(this._global.baseAPIUrl + 'attdashstaff',{clcd:clcd,aycd:aycd,atdt:cbclid} )
      .pipe(map((data: any) => {
         console.log('retres', data);
          return data;
      }));
}


getattstfdashlayout(cbclid,obj) {
  let clcd=this.clcd;
  let aycd=this.aycd;
 
  //let cbclid=obj.cbclid;
  return this.http.post(this._global.baseAPIUrl + 'attdashstafflayout',{clcd:clcd,aycd:aycd,atdt:cbclid,clid:obj.clid,crid:obj.crid,scid:obj.secid} )
      .pipe(map((data: any) => {
        console.log('retres', data);
          return data;
      }));
}



getlastfewdates() {
 
 
  //let cbclid=obj.cbclid;
  return this.http.get(this._global.baseAPIUrl + 'getlastfewdates/'+this.clcd+'/'+this.aycd)
      .pipe(map((data: any) => {
          return data;
      }));
}


getattdashstudent(cbclid) {
debugger
  let clcd=this.clcd;
  let aycd=this.aycd;
 
  //let cbclid=obj.cbclid;
  return this.http.post(this._global.baseAPIUrl + 'attdashstudent',{clcd:clcd,aycd:aycd,clid:cbclid} )
      .pipe(map((data: any) => {
        console.log('retres', data);
          return data.arrattstu;
      }));
}

getattdashstudentabs(cbclid) {
  let clcd=this.clcd;
  let aycd=this.aycd;
 
  //let cbclid=obj.cbclid;
  return this.http.post(this._global.baseAPIUrl + 'attdashstudentabs',{clcd:clcd,aycd:aycd,attdt:cbclid} )
      .pipe(map((data: any) => {
          return data.arrattstuabs;
      }));
}

 hrbatchsubjects(cbclid): Observable<any> {
        debugger
        // let clcd=localStorage.getItem('clcd');
        // let aycd=localStorage.getItem('aycd');libsubjectgroup
        
        return this.http.get(this.callurl + 'sel_sp_hrbatchsubjects/'+this.clcd+'/'+this.aycd+'/'+this.role+'/'+this.usid+'/'+cbclid)
        .pipe(map((data: any) => {
                console.log('retres-data', data);
                return data.sp_hrsuballot;
                
            }));
      }
}